module.exports = __webpack_public_path__ + "static/media/bg-card-service-2.a98f99d5.gif";